import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import sharedTheme from '../OverlayTheme.css';
import theme from './theme.css';

const ContentBlackout = (props = {}) => {
  const { background, title, message } = props;
  const titleClasses = classNames(theme.title, sharedTheme.title);
  const messageClasses = classNames(theme.message, sharedTheme.message);

  return (
    <div className={sharedTheme.container}>
      <img className={sharedTheme.background} src={background} alt="" />
      <div className={sharedTheme.messageContainer}>
        <div className={titleClasses}>{title}</div>
        <div className={messageClasses}>{message}</div>
      </div>
    </div>
  );
};

ContentBlackout.propTypes = {
  background: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ContentBlackout;
